export enum Preferences {
  MusicPlayback = 'musicPlayback',
  SoundEffects = 'soundEffects',
  HintsEffects = 'trainingHints',
  BadgeNotifications = 'badgeNotifications',
  FontSize = 'fontSize',
  HighContrast = 'highContrast',
  ColorTheme = 'colorThemePreference',
  // Written only when a student picked light/dark before the choice moved to the profile.
  LegacyColorTheme = 'colorTheme',
  EssayAIPaste = 'essayAIPaste'
}
